import Modal from "components/shared/Modal";

export default function ShareButton(props) {

  return (
    <>
      <Modal show={props.show} onClose={props.onClose} title="پاسخ شما">
        {props.children}
      </Modal>
    </>
  );
}
